import MicrosoftLogin from "./MicrosoftLogin";



export { MicrosoftLogin };



export default MicrosoftLogin;